<template>
  <div class="PayTransfer"
  >
    <div class="content" >
      <div class="content-item first">
        <div class="title">
          <div class="index">1</div>
          对公汇款
          <i class="icon_arrow"></i>
        </div>
        <div class="desc">转帐汇款至以下帐户（汇款时请备注：潮国创意）</div>
        <div class="receipt-info">
          <div class="receipt-item">
            <div class="label">收款公司：</div>
            <div class="value">上海图魂网络科技有限公司</div>
          </div>
          <div class="receipt-item">
            <div class="label">收款帐号：</div>
            <div class="value">03421100040015927</div>
          </div>
          <div class="receipt-item">
            <div class="label">开户银行：</div>
            <div class="value">中国农业银行股份有限公司上海浦三路支行</div>
          </div>
          <div class="copy-txt text-copy" @click="copy">复制转帐信息</div>
        </div>
      </div>
      <div class="content-item">
        <div class="title">
          <div class="index">2</div>
          提交支付凭证给客服</div>
        <div class="desc">客服电话：<span class="color-black">021-61516513</span></div>
        <div class="desc">
          <a
            :href="PAGE_LINK.SERVICE"
            target="_blank"
            class="desc">在线客服：<span class="btn">在线咨询</span></a>
        </div>
        <div class="desc">支付凭证示例：<span class="btn" @click="isShowHZ = true">
          点击查看
           <div class="huizi" v-show="isShowHZ">
            <div class="desc">支付凭证（电子回单）示例</div>
            <i class="icon-hz"></i>
            <div class="close" @click.stop.prevent="isShowHZ = false">关闭示例</div>
          </div>
        </span>


        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {fnClipboard} from "@/fn";
import { PAGE_LINK } from "@/constant/PAGE_PATH"

export default {
  name: "PayTransfer",
  data() {
    return {
      isShow: false,
      PAGE_LINK,
      isShowHZ: false,
    }
  },
  methods: {
    copy() {
      let copyContxt = "收款公司：上海图魂网络科技有限公司 收款帐号：03421100040015927 开户银行：中国农业银行股份有限公司上海浦三路支行 "
      fnClipboard.copy(copyContxt)
    }
  }
}
</script>

<style lang="scss" scoped>
.PayTransfer {
  //width: 32px;
  //height: 100px;
  cursor: pointer;
  position: relative;
  margin-top: 50px;

  .txt-transfer {
    height: 100%;
    text-align: center;
    width: 20px;
    font-size: 13px;
    color: #A9711C;
    line-height: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 10;
    @include BgImage(32px, 100px, 'pay/icon-arrow.svg');

    span {
      width: 20px;
      height: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  .content {
    display: flex;

    &.ON {
      right: 32px;
    }

    .content-item{
      &:first-child{
        margin-right: 56px;


      }
    }

    .icon_arrow{
      display: inline-block;
      width: 347px;
      height: 15px;
      @include BgImage2(347px,15px,'pay/arrow.svg?v=1');
      margin-left: 16px;
    }

    .title {
      color: #00001A;
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 16px;
      color: #00001A;
      line-height: 26px;
      margin-left: -36px;


      .index{
        width: 26px;
        height: 26px;
        background: #F7F1E5;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #895A0B;
        margin-right: 10px;
      }
    }

    .desc {
      font-size: 12px;
      color: rgba(0, 0, 26, 0.5);
      line-height: 16px;
      margin-bottom: 8px;

      .color-black {
        color: rgba(0, 0, 26, 1);
      }
    }

    .desc-box,.desc {
      display: flex;
      align-items: center;
      margin-top: 8px;

      .desc {
        margin-right: 33px;
        margin-bottom: 0;


      }
      .btn {
        display: inline-block;
        line-height: 20px;
        text-align: center;
        width: 68px;
        height: 20px;
        background: linear-gradient(360deg, #F7D380 0%, #FCEBB7 100%);
        border-radius: 10px;
        color: rgba(0, 0, 26, 1);
        position: relative;

        &:hover {
          background: linear-gradient(360deg, #FCEBB7 0%, #F7D380 100%);
        }
      }
    }

    .receipt-info {
      width: 400px;
      height: 94px;
      background: #F5F6FA;
      border-radius: 8px;
      padding: 12px 0 0 12px;
      box-sizing: border-box;
      position: relative;
      margin-bottom: 17px;

      .copy-txt {
        font-size: 12px;
        color: rgba(105, 105, 255, 1);
        line-height: 16px;
        position: absolute;
        top: 12px;
        right: 14px;
        z-index: 10;

        &:hover {
          color: rgba(105, 105, 255, 0.8);
        }

      }

      .receipt-item {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .label {
          font-size: 12px;
          color: rgba(0, 0, 26, 0.6);
          line-height: 16px;
        }

        .value {
          font-size: 12px;
          color: rgba(0, 0, 26, 1);
          line-height: 16px;
        }
      }
    }

    .huizi{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 12;
      background: #FFFFFF;
      border-radius: 12px;
      padding: 18px 20px;
      box-sizing: border-box;

      .desc{
        margin-bottom: 6px;
      }

      .icon-hz{
        @include BgImage(400px,175px,'pay/hz.jpg')
      }
      .close{
        display: inline-block;
        width: 60px;
        height: 20px;
        background: rgba(0, 0, 0, 0.45);
        border-radius: 10px;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 20px;
        text-align: center;
        position: absolute;
        top: 80px;
        right: 30px;
      }
    }

  }
}
</style>
